/**
 * tasksense-capability-service API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CapabilityFieldUpsertRequest { 
    groupName?: string;
    fieldKind: CapabilityFieldUpsertRequest.FieldKindEnum;
    cardinality: CapabilityFieldUpsertRequest.CardinalityEnum;
    required?: boolean;
    defaultValueJson?: string;
    description?: string;
    fieldOrder?: number;
    connectorType?: string;
    dataType?: string;
    enumValuesJson?: string;
    userdataType?: string;
    userdataAttrFilterJson?: string;
}
export namespace CapabilityFieldUpsertRequest {
    export const FieldKindEnum = {
        Connector: 'Connector',
        Data: 'Data'
    } as const;
    export type FieldKindEnum = typeof FieldKindEnum[keyof typeof FieldKindEnum];
    export const CardinalityEnum = {
        Single: 'single',
        List: 'list'
    } as const;
    export type CardinalityEnum = typeof CardinalityEnum[keyof typeof CardinalityEnum];
}


